// CyberTales Learning — role model (Document 2 §3, Document 5 §2)
// Frozen contract: role keys must not change without a coordinated PRD update.
export type UserRole =
  | 'individual_learner'
  | 'school_student'
  | 'teacher'
  | 'corporate_employee'
  | 'org_admin'
  | 'super_admin'

export const ROLE_LABELS: Record<UserRole, string> = {
  individual_learner: 'Individual Learner',
  school_student: 'School Student',
  teacher: 'Teacher',
  corporate_employee: 'Corporate Employee',
  org_admin: 'Organization Administrator',
  super_admin: 'Super Administrator',
}

// Roles allowed onto P2's organization-management surface (Team dashboard,
// Learner Management, org-scoped Leaderboard viewing). Individual learners,
// school students, and corporate employees never see these routes.
export const ORG_MANAGER_ROLES: UserRole[] = ['org_admin', 'teacher', 'super_admin']

export const ROLE_DESCRIPTIONS: Record<UserRole, string> = {
  individual_learner: 'Self-directed learner exploring CyberTales Learning on their own.',
  school_student: 'Learner enrolled through Demo School.',
  teacher: 'Manages a class within Demo School.',
  corporate_employee: 'Learner completing mandatory training at Demo Enterprise.',
  org_admin: 'Manages users, assignments, and reporting for their organization.',
  super_admin: 'Platform operator with full cross-organization access.',
}
